<div class="row justify-content-center bgDiv">
	<div class="col-11">
		<p>
		  final-design-proposal works!
		</p>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/customer/final-design-proposal/final-design-proposal.component.html